import { render } from "./SpotBalanceActionNumberWidgetLayout.vue?vue&type=template&id=5473b3aa"
import script from "./SpotBalanceActionNumberWidgetLayout.vue?vue&type=script&lang=js"
export * from "./SpotBalanceActionNumberWidgetLayout.vue?vue&type=script&lang=js"
script.render = render

export default script